"use client";

import { cn } from "@/lib/utils";

export type PublishVariant =
  | "indigo"
  | "violet"
  | "sky"
  | "amber"
  | "emerald"
  | "rose";

const variantBtn: Record<PublishVariant, string> = {
  indigo:
    "bg-indigo-600 hover:bg-indigo-700 shadow-[0_1px_3px_rgba(0,0,0,0.06),0_6px_20px_-6px_rgba(99,102,241,0.60)] hover:shadow-[0_4px_20px_-4px_rgba(99,102,241,0.55)]",
  violet:
    "bg-violet-600 hover:bg-violet-700 shadow-[0_1px_3px_rgba(0,0,0,0.06),0_6px_20px_-6px_rgba(139,92,246,0.60)] hover:shadow-[0_4px_20px_-4px_rgba(139,92,246,0.55)]",
  sky:
    "bg-sky-500 hover:bg-sky-600 shadow-[0_1px_3px_rgba(0,0,0,0.06),0_6px_20px_-6px_rgba(14,165,233,0.60)] hover:shadow-[0_4px_20px_-4px_rgba(14,165,233,0.55)]",
  amber:
    "bg-amber-500 hover:bg-amber-600 shadow-[0_1px_3px_rgba(0,0,0,0.06),0_6px_20px_-6px_rgba(245,158,11,0.60)] hover:shadow-[0_4px_20px_-4px_rgba(245,158,11,0.55)]",
  emerald:
    "bg-emerald-600 hover:bg-emerald-700 shadow-[0_1px_3px_rgba(0,0,0,0.06),0_6px_20px_-6px_rgba(16,185,129,0.55)] hover:shadow-[0_4px_20px_-4px_rgba(16,185,129,0.5)]",
  rose:
    "bg-rose-500 hover:bg-rose-600 shadow-[0_1px_3px_rgba(0,0,0,0.06),0_6px_20px_-6px_rgba(244,63,94,0.55)] hover:shadow-[0_4px_20px_-4px_rgba(244,63,94,0.5)]",
};

interface ComposeActionsProps {
  onPublish: () => void;
  loading?: boolean;
  disabled?: boolean;
  loadingText?: string;
  publishText?: string;
  secondary?: React.ReactNode;
  publishVariant?: PublishVariant;
  className?: string;
  compact?: boolean;
}

export function ComposeActions({
  onPublish,
  loading,
  disabled,
  loadingText = "Publicando...",
  publishText = "Publicar",
  secondary,
  publishVariant = "indigo",
  className,
  compact = false,
}: ComposeActionsProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-between border-t border-slate-100/80 dark:border-zinc-800/60",
        compact ? "px-2 pb-2 pt-2 sm:px-2.5" : "px-3 pb-4 pt-3 sm:px-4 sm:pb-5",
        className
      )}
    >
      <div className="flex items-center">{secondary}</div>

      <button
        type="button"
        onClick={onPublish}
        disabled={disabled || loading}
        className={cn(
          "relative flex items-center gap-1.5 overflow-hidden font-semibold text-white",
          compact ? "rounded-xl px-4 py-2 text-xs" : "rounded-2xl px-5 py-2.5 text-[13px]",
          "transition-all duration-300 hover:-translate-y-0.5 active:translate-y-0 active:scale-[0.98]",
          "disabled:cursor-not-allowed disabled:opacity-50",
          variantBtn[publishVariant],
        )}
      >
        {/* Specular highlight — same language as glass badges */}
        <span
          aria-hidden
          className="pointer-events-none absolute inset-x-0 top-0 h-[45%] rounded-t-2xl bg-gradient-to-b from-white/30 to-transparent"
        />
        {loading ? (
          <>
            <div className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-white/30 border-t-white" />
            <span>{loadingText}</span>
          </>
        ) : (
          publishText
        )}
      </button>
    </div>
  );
}
